'use client'

import * as React from 'react'
import { LazyMotion, domAnimation, m, useReducedMotion } from 'framer-motion'
import type { Variants } from 'framer-motion'
import { EASE, VIEWPORT } from '@/lib/motion'

// Motion leaves for the pricing page's comparison table. Table rows fade
// in on a very tight cascade (opacity only — transforms on table rows
// have cross-browser layout quirks). Plays once; reduced motion renders
// the final state immediately.

const body: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.012 } },
}

const row: Variants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.3, ease: EASE } },
}

export function TableBodyReveal({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  const reduce = useReducedMotion()
  return (
    <LazyMotion features={domAnimation}>
      <m.tbody
        className={className}
        initial={reduce ? false : 'hidden'}
        whileInView={reduce ? undefined : 'show'}
        viewport={VIEWPORT}
        variants={body}
      >
        {children}
      </m.tbody>
    </LazyMotion>
  )
}

export function TableRowReveal({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  const reduce = useReducedMotion()
  return (
    <m.tr className={className} initial={reduce ? false : undefined} variants={reduce ? undefined : row}>
      {children}
    </m.tr>
  )
}
